// extracted by mini-css-extract-plugin
module.exports = {"vehicleFormGroup":"styles_vehicleFormGroup__9lvoz","vehicleFormGroupSecondBlock":"styles_vehicleFormGroupSecondBlock__y7_av","btnFormGroup":"styles_btnFormGroup__3v72k"};